export default __webpack_public_path__ + "static/media/rejectIcon.fe45c2ef.svg";